module.exports = __webpack_public_path__ + "static/media/Total_Range_Active.24d7df97.svg";